import { render, staticRenderFns } from "./StartupsBoard.vue?vue&type=template&id=46b55a45&scoped=true&"
import script from "./StartupsBoard.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupsBoard.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b55a45",
  null
  
)

export default component.exports